/**
  メイントップページ
*/
<template>
  <v-ons-page>
    <ms-toolbar mode="order"></ms-toolbar>
    <div class="content">
      
      <h3>{{localizeLabel("Order", "label_select_menu")}}</h3>
      <div class="item_list">
        <div class="item_list-item" v-for="(item,index) in GoodsStatus" :v-if="refresh" :key="index">
          <div class="link_block " :class="checkLinkStatus(item)"  @click="handleClickLink(item)" :data-status="item.goods_status" :data-status2="item.goods_status2">
              <div class=notice_block>
                <img src="../assets/img/notice.svg" class="ico_notice" alt="">
                <p class="txt_notice" v-html="getStatusText(item)"></p>
              </div>
              <ons-ripple class="ripple"></ons-ripple>
          </div>
          <div class="left">
            <div v-if="item.img_url==''" class="list-item__thumbnail no-item-img" alt=""></div>
            <img v-if="item.img_url!=''" class="list-item__thumbnail" :src="item.img_url">
          </div>
          <div class="center">
            <span v-if="currentLangCode=='ja'" class="list-item__title">{{item.GoodsName}}</span>
            <span v-if="currentLangCode=='en'" class="list-item__title">{{item.GoodsNamee}}</span>
            <span v-if="currentLangCode=='ch'" class="list-item__title">{{item.GoodsNamec}}</span>
          </div>
          <div class="right">
             <v-ons-icon icon="fa-chevron-right"></v-ons-icon>
          </div>
        </div>
      </div>
      
      
    </div>
  </v-ons-page>
</template>

<script>
import Tabbar from "../components/msTabbar";
import Toolbar from "../components/msToolbar";
//import WaitingIcon from "../components/WaitingIcon";
import { mapGetters, mapActions } from "vuex";
//import moment from "moment";
//import "moment/locale/ja";

export default {
  name: "itemSelect",
  data() {
    return {
      refresh:true,
      itemList:[],
     }
  },
  created: function() {
   

    this.GoodsStatus.forEach(goods=>{
      goods['type']='item-link'
      goods['code']=goods.Goods
      goods['goods_status']=goods.GoodsStatus
      goods['goods_status2']=goods.GoodsStatus2
      goods['lock_time']=goods.LockTime
      //self.refresh = false;
      //self.refresh = true; //強制的にカルーセルを再描画
    })

    
    this.setLoadingScreenVisibility(false)
    
  },
  computed: {
    ...mapGetters([
      'GoodsInfo',
      'checkLinkStatus',
      'getStatusText',
      'GoodsStatus',
      "localizeLabel",
      'currentLangCode',
      ]),
      checkOrderable(){
        if(this.cartItem.count==0){
          return true
        }
        if(this.categoryItem.select_mode==1 && this.categoryItem.last_count>0){
          return true
        }
        return false
      },
  },
  methods: {
    ...mapActions([
      'GetGoodsInfo',
      'GetGoodsStatus',
      'navigateOrderPage',
      'showErrorMessage',
      'setLoadingScreenVisibility',
      'navigateLink',
    ]),
    handleClickLink(item){
      if(item.type=="outpage-link"){
        window.open(item.code, '_blank')
      }else{
        this.navigateLink({item:item,back_flag:true})
      }
    },
    moveOrderPage(item){
      
      this.navigateOrderPage({menu:'order', code:item.Goods, data:{mode:'back', item_info:item}})
    },
    getGoodsStatus(){
      var self=this
      var param=[]
      this.itemList.forEach(item=>{
        param.push({ code:item.Goods})
      })
      this.GetGoodsStatus(param)
      .then(goods_status=>{
        //取得したステータスをページ設定アイテムに詰める
        //this.showLogMessage('欠品照会API取得')
        goods_status.forEach(goods=>{
          self.itemList.forEach(item=>{
            if(Number(item.Goods)==Number(goods.Goods)){
              item['goods_status']=goods.GoodsStatus
              item['goods_status2']=goods.GoodsStatus2
              item['lock_time']=goods.LockTime
            }
          })
        })
        this.refresh = false;
        this.refresh = true; //強制的にカルーセルを再描画
      })
      .catch(()=>{
        this.setLoadingScreenVisibility(false)
      })
    
    }
  },
  
  components: {
    "ms-tabbar": Tabbar,
    "ms-toolbar": Toolbar,
    //"mc-waiting-icon": WaitingIcon
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style  lang="scss" scoped>
@import "../assets/sass/base.scss";
.content{
  //background-color: #111!important;
  background: $background-image-path!important;
  background-size: cover!important;
  color: $base-font-color;
}
ons-toolbar{
    //background: black;
  background: $background-image-path;
  color: $base-font-color;
  border-bottom: 1px solid gray;
}
h3{
  text-align: center;
  font-size: 16px;
}
.list-item__thumbnail{
  width: 80px;
  height: 60px;
  margin-right: 10px;
  @media screen and (min-width: 768px) {
    width: 140px;
    height: 100px;
  }
}
.list-item__title{
  color: $base-font-color;
  font-size: 14px;
  align-self: center!important;
  
  @media screen and (min-width: 768px) {
    font-size: 16px;

  }
}
.list-item__center{
  background-image: none;
}
.item_list{
  border-top: 1px dotted gray;
  
}
.item_list-item{
  box-sizing: border-box;
  position: relative;
  border-bottom: 1px dotted gray;
  padding: 10px 15px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  .center{
    flex: 1;
  }
  .link_block{
    position: absolute;
    top: 0;
    bottom: 0;
    right: 0;
    left: 0;
  }
}

.no-item-img{

    background: $no-item-image-path no-repeat;
    background-size: cover;
    background-position: center;
}
.notice_block{
  flex-direction:row!important;
  .ico_notice{
    width:35px;
    margin: 5px;
  }
  .txt_notice{
    display:inline-block;
    //padding: 3px 10px;
  }
}
/****************************/
</style>



// WEBPACK FOOTER //
// src/pages/ItemSelectPage.vue